// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddUpdateModal_modal__5xeYK{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color:rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.AddUpdateModal_container__gL-OS{
    position: relative;
    height: 90%;
    max-height: 650px;
    width: 85%;
    max-width: 760px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.AddUpdateModal_header__SrEe0{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.AddUpdateModal_close__DZdDS{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.AddUpdateModal_form__hHREL{
    height: calc(100% - 50px);
}
.AddUpdateModal_formInputs__qftzj{
    height: calc(100% - 80px);
    overflow-y: auto;
    overflow-x: hidden;
}
.AddUpdateModal_input__bBOfJ{
    display: block !important;
    margin-top: 20px;
}
.AddUpdateModal_input__bBOfJ input{
    width: calc(100% - 44px);
}
.AddUpdateModal_textEditor__3oNvd{
    display: block !important;
    height: 252px;
    margin-top: 20px;
    margin-bottom: 40px;
}
.AddUpdateModal_textEditor__3oNvd textarea{
    width: calc(100% - 48px);
}
.AddUpdateModal_buttons__FINtn{
    display: flex;
    margin-top: 35px;
}
.AddUpdateModal_buttonsApiError__hRFnr{
    margin-top: 9px;
}
.AddUpdateModal_button__ZDzte{
    width: calc(50% - 8px);
    padding-left: 50px;
    padding-right: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/AddUpdateModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color:rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    height: 90%;\n    max-height: 650px;\n    width: 85%;\n    max-width: 760px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.form{\n    height: calc(100% - 50px);\n}\n.formInputs{\n    height: calc(100% - 80px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.input{\n    display: block !important;\n    margin-top: 20px;\n}\n.input input{\n    width: calc(100% - 44px);\n}\n.textEditor{\n    display: block !important;\n    height: 252px;\n    margin-top: 20px;\n    margin-bottom: 40px;\n}\n.textEditor textarea{\n    width: calc(100% - 48px);\n}\n.buttons{\n    display: flex;\n    margin-top: 35px;\n}\n.buttonsApiError{\n    margin-top: 9px;\n}\n.button{\n    width: calc(50% - 8px);\n    padding-left: 50px;\n    padding-right: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `AddUpdateModal_modal__5xeYK`,
	"container": `AddUpdateModal_container__gL-OS`,
	"header": `AddUpdateModal_header__SrEe0`,
	"close": `AddUpdateModal_close__DZdDS`,
	"form": `AddUpdateModal_form__hHREL`,
	"formInputs": `AddUpdateModal_formInputs__qftzj`,
	"input": `AddUpdateModal_input__bBOfJ`,
	"textEditor": `AddUpdateModal_textEditor__3oNvd`,
	"buttons": `AddUpdateModal_buttons__FINtn`,
	"buttonsApiError": `AddUpdateModal_buttonsApiError__hRFnr`,
	"button": `AddUpdateModal_button__ZDzte`
};
export default ___CSS_LOADER_EXPORT___;
